import React from "react";
import useProductName from "brand-customization/useProductName";
import { Row, Col } from "components/bootstrap";
import DocsHelper from "util/DocsHelper";
import { DocumentTitle, PageHeader } from "components/common";
import AuditLogStatus from "auditlog/AuditLogStatus";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import { AUDIT_LOG_LICENSE_TITLE, AUDIT_LOG_LICENSE_TEXT } from "auditlog/constants";
import AuditLogPageNavigation from "./AuditLogPageNavigation";
const AuditLogConfigurationPage = () => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Audit log configuration" }, /* @__PURE__ */ React.createElement(AuditLogPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "Audit Log Configuration",
      documentationLink: {
        title: "Audit log documentation",
        path: DocsHelper.PAGES.AUDIT_LOG
      }
    },
    /* @__PURE__ */ React.createElement("span", null, "The Audit Log lets you create a chronological record of activities performed in ", productName, ", that you can later use to reconstruct and examine the sequence of events that occurred when investigating an event. You can modify the audit log configuration in the ", productName, " configuration file. Please remember to restart the server afterwards.")
  ), /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      text: AUDIT_LOG_LICENSE_TITLE,
      title: AUDIT_LOG_LICENSE_TEXT,
      licenseSubject: LICENSE_SUBJECTS.auditlog,
      displayWarningContainer: true,
      bsStyle: "danger"
    }
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(AuditLogStatus, null))));
};
export default AuditLogConfigurationPage;
